import { Link } from "react-router-dom";

const CartItem = ({
  item,
  qtyChangeHandler,
  removeHandler,
  quantity,
  storeCurrency,
}) => {
  return (
    <tr className="border-b">
      <td className="flex items-center gap-4">
        <img src={item.image} alt={item.name} className="w-20 h-20" />
        <Link to={`/product/${item._id}`}>
          <p className="text-black m-0">{item.name}</p>
        </Link>
      </td>
      <td>
        {storeCurrency} {item.price}
      </td>
      <td>{quantity}</td>
      <td onClick={() => removeHandler(item)} className="anker cursor-pointer">
        X
      </td>
    </tr>
  );
};

export default CartItem;
{
  /* <select
        value={quantity}
        onChange={(e) => qtyChangeHandler(item, e.target.value)}
        className="cartItem__select"
        disabled
      >
        {[...Array(item.countInStock).keys()].map((x) => (
          <option key={x + 1} value={x + 1}>
            {x + 1}
          </option>
        ))}
      </select> */
}
